<template>
	<div class="feedback-page">
	
		<div class="header">
			
			<div class="header-content">
				<div class="header-icon">
					<img src="../../assets/newHome1/反馈投诉海报.png" alt="反馈图标" />
				</div>
			</div>
		</div>
		<!-- 主要内容区 -->
		<div class="main-content">
			<!-- 左侧反馈内容 -->
			<div class="left-section">
				<div class="subsection-title">请填写您的反馈信息</div>
				
				<!-- 反馈内容输入 -->
				<div class="input-container">
					<textarea v-model="feedbackForm.content" placeholder="您的问题与建议，将直接同步董事长账号，我们会尽快回复..." class="feedback-input"></textarea>
				</div>
				
				<!-- 问题严重类型 -->
				<div class="severity-section">
					<div class="subsection-title">问题严重类型</div>
					<div class="severity-options">
						<button
							v-for="(option, index) in severityOptions" 
							:key="index" 
							class="severity-option" 
							:class="{ active: feedbackForm.dem_num === option.value }"
							@click="feedbackForm.dem_num = option.value"
						>
							{{ option.label }}
						</button>
					</div>
				</div>
				
				
				
				
			</div>
			<!-- 右侧图片上传 -->
			<div class="right-section">
				<div class="subsection-title">上传图片</div>
				<el-upload
				  :action="$axios.defaults.baseURL+'index.php?act=upload&op=image'"
				  :data="{store_id:this.$store.state.store_id}"
				  :headers="{'token':$store.state.token}"
				  name="image"
				  list-type="picture-card"
				  :on-success="upImgSuccess"
				  :limit="9"
				  :on-remove="(file)=>{fileDel(file,'imgList')}"
				  multiple
				>
				  <i class="el-icon-plus"></i>
				</el-upload>
			</div>
		</div>
		<!-- 提交按钮 -->
		<div class="submit-section">
			<!-- 董事长专线 -->
			<div class="contact-section">
				<div class="contact-item">
					<img src="../../assets/newHome1/董事长专线.png" alt="电话图标" class="contact-icon" />
					<span class="contact-label">董事长专线：</span>
					<span class="contact-value">13816821903</span>
				</div>
			</div>
			<button class="submit-btn" @click="submitFeedback">提交反馈</button>
		</div>
	</div>
</template>

<script>
export default {
	
	data() {
		return {
			
			// 反馈表单数据
			feedbackForm: {
				content: "",
				dem_num: "1",
				img_name: ""
			},
			// 严重程度选项
			severityOptions: [
				{ label: "一般", value: "1" },
				{ label: "严重", value: "2" },
				{ label: "很严重", value: "3" }
			],
			// 上传图片列表
			imgList: []
		}
	},
	methods: {
		// 图片上传成功回调
		upImgSuccess(res) {
			console.log("图片上传成功", res);
			this.imgList.push(res.data);
			// 将图片URL保存到表单数据中
			this.feedbackForm.img_name = this.imgList.map(item => item.url).join(",");
		},
		
		// 文件删除回调
		fileDel(file, type = "imgList") {
			console.log("删除文件", file);
			this[type] = this[type].filter(item => item.url != file.response.data.url);
			
			// 更新表单数据
			if (type === "imgList") {
				this.feedbackForm.img_name = this.imgList.map(item => item.url).join(",");
			}
			
			console.log("更新后的文件列表", this[type]);
		},
		
		// 提交反馈
		submitFeedback() {
			if (!this.feedbackForm.content) {
				this.$message.error('请输入反馈内容');
				return;
			}
			
			try {
				// 提交反馈
				this.$api.pubDemand({
					store_id: this.$store.state.store_id,
					store_name: this.$store.state.store_name,
					member_id: this.$store.state.member_id,
					member_name: this.$store.state.member_name,
					parts_cri: this.feedbackForm.content,
					dem_type: 3, // 反馈类型
					img_name: this.feedbackForm.img_name,
					dem_num: this.feedbackForm.dem_num
				}).then(res => {
					this.$message.success("反馈提交成功");
					
					// 重置表单
					this.feedbackForm.content = "";
					this.feedbackForm.dem_num = "1";
					this.feedbackForm.img_name = "";
					this.imgList = [];
				}).catch(error => {
					this.$message.error("反馈提交失败");
				});
			} catch (error) {
				this.$message.error("反馈提交失败");
			}
		}
	}
}
</script>

<style lang="scss">
	.feedback-page {
		min-height: 100vh;
		background: #ffffff;
		
		.header {
			padding: 20px 0;
			.header-content {
				display: flex;
				max-width: 1200px;
				margin: 0 auto;
				
				
				
				.header-icon {
					img {
						width: 100%;
					}
				}
			}
		}
		.subsection-title {
					font-size: 20px;
					color: #333333;
					margin-bottom: 10px;
				}
		.main-content {
			display: flex;
			max-width: 1200px;
			margin: 0 auto;
			padding: 0 20px;
			gap: 40px;
			
			.left-section {
				flex: 1;
				
				
				
				.input-container {
					margin-bottom: 20px;
					
					.feedback-input {
						width: 100%;
						height: 150px;
						padding: 20px;
						border: 1px solid #e8e8e8;
						border-radius: 8px;
						font-size: 16px;
						color: #333333;
						resize: none;
						box-sizing: border-box;
						outline: none;
						&::placeholder {
							color: #999999;
						}
					}
				}
				
				.severity-section {
					margin-bottom: 20px;
					
					.subsection-title {
						font-size: 20px;
						color: #333333;
						margin-bottom: 10px;
					}
					
					.severity-options {
						display: flex;
						gap: 20px;
						
						.severity-option {
							padding: 10px 24px;
							border: 1px solid #e8e8e8;
							border-radius: 20px;
							background: #ffffff;
							font-size: 16px;
							color: #666666;
							cursor: pointer;
							transition: all 0.3s ease;
							
							&:hover {
								border-color: #667eea;
								color: #667eea;
							}
							
							&.active {
								background: #667eea;
								color: #ffffff;
								border-color: #667eea;
							}
						}
					}
				}
				
				
				
				
			}
			
			.right-section {
				width: 500px;
				
				.subsection-title {
					font-size: 20px;
					color: #333333;
					margin-bottom: 10px;
				}
				
				.upload-container {
					border: 2px dashed #e8e8e8;
					border-radius: 8px;
					padding: 20px;
					min-height: 200px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					
					.upload-item {
						position: relative;
						width: 100%;
						height: 150px;
						margin-bottom: 10px;
						
						.uploaded-image {
							width: 100%;
							height: 100%;
							border-radius: 8px;
							object-fit: cover;
						}
						
						.delete-btn {
							position: absolute;
							top: -10px;
							right: -10px;
							width: 30px;
							height: 30px;
							background-color: #ff4d4f;
							border-radius: 50%;
							color: white;
							font-size: 20px;
							border: none;
							cursor: pointer;
							display: flex;
							align-items: center;
							justify-content: center;
						}
					}
					
					.upload-btn {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						width: 100%;
						height: 150px;
						cursor: pointer;
						
						.plus {
							font-size: 40px;
							color: #999999;
							margin-bottom: 10px;
						}
						
						.upload-text {
							font-size: 16px;
							color: #999999;
						}
					}
				}
			}
		}
		.submit-section {
			padding-bottom: 10px;
			
			width: 1200px;
			margin: 0 auto;
			text-align: center;
			.contact-section {
				margin-bottom: 10px;
				border-top: 1px solid #DDDDDD;
				padding-top: 10px;
				.contact-item {
					display: flex;
					align-items: center;
					
					.contact-icon {
						width: 24px;
						height: 24px;
						margin-right: 10px;
					}
					
					.contact-label {
						font-size: 16px;
						color: #666666;
					}
					
					.contact-value {
						font-size: 16px;
						color: #333333;
						font-weight: 500;
					}
				}
			}
			.submit-btn {
				width: 200px;
				height: 48px;
				background: #667eea;
				border: none;
				border-radius: 24px;
				font-size: 18px;
				font-weight: 600;
				color: #ffffff;
				cursor: pointer;
				transition: all 0.3s ease;
				
				&:hover {
					background: #5a6fd8;
				}
				
				&:active {
					opacity: 0.9;
					transform: scale(0.98);
				}
			}
		}
	}
</style>